export function getPath(state) {
	var fullPath = "/class_results";

	if (state.reportUserID) {
		fullPath += "/" + state.reportUserID;
	}

	var queryParts = [];

	if (state.hideNames) {
		queryParts.push("hide_names=" + state.hideNames);
	}

	if (state.reportLock) {
		queryParts.push("report_lock=" + state.reportLock);
	}

	if (queryParts.length) {
		fullPath += "?" + queryParts.join("&");
	}

	return fullPath;
}

export function getQuery(state) {
	var query = {
		precompute_cache: true
	};

	if (state.reportUserID) {
		query.report_user_id = state.reportUserID;
	}

	if (state.hideNames) {
		query.hide_names = true;
	}

	if (state.reportLock) {
		query.report_lock = state.reportLock;
	}

	return query;
}

export function getRouteState(params) {
	var state = {};

	state.reportUserID = params.report_user_id;

	if (params.hide_names) {
		state.hideNames = true;
	} else {
		state.hideNames = false;
	}
	
	if (params.report_lock) {
		state.reportLock = params.report_lock;
	}
	
	return state;
}

export var PATH = "/class_results/:report_user_id";


// WEBPACK FOOTER //
// ./modules/lib/routing/ClassResultsRouting.js